import React from 'react';
import { CompanyConfiguration, User } from '@gloat/types';
import { TranslateProps } from '@gloat/glocalize';

interface useCustomFieldsArgs {
  feature: 'careerUserProfile' | 'hireCandidateProfile' | 'hireAdminConsole' | 'careerUserProfilePersonalInfo';
  customFields?: User['customFields'];
  companyConfig?: CompanyConfiguration;
  translateFunction: (props: TranslateProps) => string | undefined;
}

type ReturnedFieldObjectType = {
  value: string | number | boolean | null | undefined;
  label: React.ReactNode;
};

// this hooks accepts a feature name and a custom fields object (that is the data we work with).
// it checks on company config what are the fields we need to display and returns an array
// of objects with the label and value of the fields we need to display.
const useSpecificFeatureCustomFields = ({
  feature,
  customFields,
  companyConfig,
  translateFunction,
}: useCustomFieldsArgs): ReturnedFieldObjectType[] => {
  const { featuresCustomFields, fields = {} } = companyConfig || {};
  const fieldsData = { ...fields?.user?.custom, ...fields?.user?.builtin };

  const array: ReturnedFieldObjectType[] = [];
  featuresCustomFields?.[feature]?.forEach(field => {
    const fieldData = fieldsData?.[field];
    const fieldValue = customFields?.[field];
    if (fieldData && fieldValue !== null && fieldValue !== undefined) {
      array.push({
        label: translateFunction({
          id: fieldData?.i18nLabelId,
          defaultMessage: fieldData?.displayName,
        }),
        value: typeof fieldValue === 'object' ? JSON.stringify(fieldValue) : fieldValue,
      });
    }
  });

  return array.filter(obj => obj.value !== null && obj.value !== undefined);
};

export default useSpecificFeatureCustomFields;
